module.exports = __webpack_public_path__ + "static/media/strike-through.0ffc26d2.svg";